import React from 'react';

const ListView = ({ folders, files }) => {
  return <div>[List View]</div>;
};

export default ListView;
